import type { SolarSystemPlanet, SolarSystemView } from '@kaeliux/shared';
import { authedPost } from './http';
import { normalizeSunStatus } from './sunControlNormalization';

/**
 * Galaxy-map reads (issue #15). Unlike the player's own subtree, other
 * players' planets are NOT client-readable under the security rules, so
 * this goes through the `/getSolarSystem` Cloud Function, which runs the
 * cross-player collection-group query server-side and returns a sanitized
 * view (no resources/buildings/ships).
 */

/** Load all occupied positions of one `galaxy:system` solar system. */
export async function getSolarSystem(galaxy: number, system: number): Promise<SolarSystemView> {
    const view = await authedPost<SolarSystemView>('/getSolarSystem', { galaxy, system });
    return view.sun ? { ...view, sun: normalizeSunStatus(view.sun) } : view;
}

/** Load a single position of a system, or null when it's unoccupied. */
export async function getPlanet(
    galaxy: number,
    system: number,
    position: number,
): Promise<SolarSystemPlanet | null> {
    const view = await getSolarSystem(galaxy, system);
    return view.planets.find((planet) => planet.position === position) ?? null;
}
